import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

const AskedQuestions = () => {
  return (
    <section
      id="faq"
      className="w-full overflow-x-hidden lg:px-21 md:px-10 px-4 py-5"
    >
      <div className="max-w-7xl mx-auto text-center mb-8">
        <h2 className="md:text-4xl text-3xl font-semibold text-gray-900 mb-4">
          Frequently Asked Questions
        </h2>
        <p className="md:text-xl text-base font-normal text-gray-500">
          Everything you need to know about our service
        </p>
      </div>

      <div className="space-y-5">
        <Disclosure
          as="div"
          className="rounded-2xl border border-gray-100 shadow"
        >
          <DisclosureButton className="w-full h-full flex items-center justify-between gap-6 cursor-pointer p-4 md:p-6 text-left">
            <span className="text-base font-medium text-gray-900 flex-1">
              Do I need an account to submit a service request?
            </span>
            <ChevronDownIcon className="md:size-6 size-5 fill-gray-900 shrink-0 group-data-open:rotate-180" />
          </DisclosureButton>
          <DisclosurePanel className="px-4 md:px-6 pb-4 mt-1 text-base font-normal text-gray-500">
            No. You can submit and track your service using your order ID.
            Creating an account is optional but allows you to view your full
            order history, track your progress, and manage multiple service
            orders easily. By using the same link, you will always be directed
            back to your service order page.
          </DisclosurePanel>
        </Disclosure>

        <Disclosure
          as="div"
          className="rounded-2xl border border-gray-100 shadow"
        >
          <DisclosureButton className="w-full h-full flex items-center justify-between gap-6 cursor-pointer p-4 md:p-6 text-left">
            <span className="text-base text-start font-medium text-gray-900">
              What if my part number is not in the list?
            </span>
            <ChevronDownIcon className="md:size-6 size-5 fill-gray-900 shrink-0 group-data-open:rotate-180" />
          </DisclosureButton>
          <DisclosurePanel className="px-4 md:px-6 pb-4 mt-1 text-base font-normal text-gray-500">
            If your part number is not in the list, please upload a picture of
            the module. Our team will review the part number from the photo and
            confirm if it is supported. You can also enter the part number
            manually if you prefer.
          </DisclosurePanel>
        </Disclosure>

        <Disclosure
          as="div"
          className="rounded-2xl border border-gray-100 shadow"
        >
          <DisclosureButton className="w-full h-full flex items-center justify-between gap-6 cursor-pointer p-4 md:p-6 text-left">
            <span className="text-base text-start font-medium text-gray-900">
              Can I use my eBay order to autofill my information?
            </span>
            <ChevronDownIcon className="md:size-6 size-5 fill-gray-900 shrink-0 group-data-open:rotate-180" />
          </DisclosureButton>
          <DisclosurePanel className="px-4 md:px-6 pb-4 mt-1 text-base font-normal text-gray-500">
            At this time, we do not autofill information from eBay orders, as we
            collect a few additional details when you submit a service request.
            You only need to enter your return address if you want the item
            shipped to a different address than the one on your eBay order.
          </DisclosurePanel>
        </Disclosure>

        <Disclosure
          as="div"
          className="rounded-2xl border border-gray-100 shadow"
        >
          <DisclosureButton className="w-full h-full flex items-center justify-between gap-6 cursor-pointer p-4 md:p-6 text-left">
            <span className="text-base text-start font-medium text-gray-900">
              How will I know when my item is received?
            </span>
            <ChevronDownIcon className="md:size-6 size-5 fill-gray-900 shrink-0 group-data-open:rotate-180" />
          </DisclosureButton>
          <DisclosurePanel className="px-4 md:px-6 pb-4 mt-1 text-base font-normal text-gray-500">
            Once your module has been serviced and shipped back, you can track
            the return shipment using the tracking number provided in your eBay
            order.
          </DisclosurePanel>
        </Disclosure>

        <Disclosure
          as="div"
          className="rounded-2xl border border-gray-100 shadow"
        >
          <DisclosureButton className="w-full h-full flex items-center justify-between gap-6 cursor-pointer p-4 md:p-6 text-left">
            <span className="text-base text-start font-medium text-gray-900">
              Is my information secure?
            </span>
            <ChevronDownIcon className="md:size-6 size-5 fill-gray-900 shrink-0 group-data-open:rotate-180" />
          </DisclosureButton>
          <DisclosurePanel className="px-4 md:px-6 pb-4 mt-1 text-base font-normal text-gray-500">
            Yes. Your information is used solely for processing your service
            requestand return shipping. We do not share, sell, or distribute
            your personal information to third parties.
          </DisclosurePanel>
        </Disclosure>
      </div>
    </section>
  );
};

export default AskedQuestions;
